export const gameFeed = {
  gameFeed: "游戏动态",
  gameFeedTitle: "游戏动态",
  gameFeedLoading: "正在加载游戏...",
  gameFeedLike: "喜欢",
  gameFeedUnlike: "取消喜欢",
  gameFeedLikeSingular: "喜欢",
  gameFeedLikePlural: "喜欢",
  gameFeedComments: "评论",
  gameFeedNoComments: "还没有评论，快来第一个评论吧！",
  gameFeedAddComment: "添加评论...",
  gameFeedCommentModerated: "您的评论未发布，因为它违反了平台政策。请保持评论尊重。",
  gameFeedCommentSupportRedirect: "如有提款或付款问题，请联系我们的客服团队。此区域仅用于游戏评论。",
  gameFeedPost: "发布",
  gameFeedDelete: "删除",
  gameFeedLoginToComment: "登录后评论",
  gameFeedLoginToLike: "登录后点赞",
  gameFeedReply: "回复",
  gameFeedReplyPlaceholder: "写一条回复...",
  gameFeedViewReplies: "查看回复 ({{count}})",
  gameFeedViewMoreReplies: "查看更多回复",
  gameFeedHideReplies: "收起回复",
  gameFeedEndOfFeed: "你已经看完了所有游戏！",
  gameFeedCloseGame: "关闭游戏",
  gameFeedExpandGame: "全屏显示游戏",
  gameFeedDeposit: "充值",
  gameFeedBadgeHot: "热门",
  gameFeedBadgeNew: "最新",
  gameFeedBadgeBigWinner: "大奖",
  gameFeedSwipeForAnotherGame: "在此滑动切换其他游戏",
  gameFeedSwipeShort: "上滑以查看更多游戏",
  providerProfileBack: "返回",
  providerProfileGames: "游戏",
  providerProfileFollowers: "关注者",
  providerProfileFollow: "关注",
  providerProfileFollowing: "已关注",
  providerProfileGridView: "网格视图",
  providerProfileListView: "列表视图",
  providerProfileNoGames: "该提供商暂无可用游戏。",
  providerProfileClose: "关闭",
  providerProfilePlayGame: "开始游戏",
  providerDescDefault: "在线赌场游戏提供商。",
  providerDescPragmatic: "全球老虎机和真人游戏领导者。Gates of Olympus、Sweet Bonanza和Wolf Gold的创造者。",
  providerDescBgaming: "创新的iGaming工作室，提供可验证公平的老虎机、独特机制和鲜明设计。",
  providerDescEvoplay: "3D游戏和游戏化先驱。电影级沉浸式体验。",
  providerDescHacksaw: "数字刮刮卡和高波动性老虎机专家，提供极致奖金。",
  providerDescEvolution: "真人赌场第一品牌。轮盘、二十一点、游戏秀和实时互动体验。",
  providerDescPixmove: "新兴工作室，提供街机-赌场混合游戏和技巧游戏机制。",
  providerDescUpgaming: "经典与现代老虎机提供商，拥有累积奖金和奖励功能。",
  providerDescEndorphina: "以文化主题、高品质画面和精确数学为特色的优质老虎机。",
  providerDescBetby: "领先的体育博彩平台，覆盖每月30,000+赛事。",
  providerDescTada: "亚洲工作室，提供色彩丰富的老虎机、大倍数乘数和令人上瘾的机制。",
  providerDescGamingcorps: "瑞典老虎机和桌游开发商，专注于品质和公平游戏。",
  providerDescKagaming: "亚洲供应商，拥有丰富的主题老虎机、捕鱼和桌游目录。",
  gameFeedFilterTitle: "筛选",
  gameFeedFilterAll: "全部",
  gameFeedFilterTopPlayed: "热门10",
  gameFeedFilterTournament: "锦标赛",
  gameFeedFilterDrop: "掉落",
  gameFeedFilterRace: "竞赛",
  gameFeedFilterSectionType: "动态类型",
  gameFeedFilterSectionProvider: "提供商",
  gameFeedFilterSectionFeatures: "特色功能",
  gameFeedFilterSelectProviderFirst: "请先选择提供商以启用特色功能",
  gameFeedFilterClear: "清除筛选",
  gameFeedFilterNoResults: "没有符合条件的游戏",
  gameFeedFilterShowMore: "查看更多",
  gameFeedFilterShowLess: "收起",
  gameFeedFilterNoGamesType: '{{provider}} 没有 "{{type}}" 游戏',
  gameFeedFilterNoFeature: "{{provider}} 没有活跃的{{feature}}",
  gameFeedFilterAccept: "应用",
  storyTopGamesTitle: "{{provider}} 最受欢迎的 3 款游戏",
};
